import { EditionType } from '@graphics/gfx-common/dist/constants'
import { IInitAction } from './init'

export enum types {
  GET_CAPABILITIES_SUMMARY__START = 'GET_CAPABILITIES_SUMMARY__START',
  GET_CAPABILITIES_SUMMARY__SUCCESS = 'GET_CAPABILITIES_SUMMARY__SUCCESS',
  GET_CAPABILITIES_SUMMARY__FAILURE = 'GET_CAPABILITIES_SUMMARY__FAILURE',
  GET_CAPABILITIES_SUMMARY__CANCEL = 'GET_CAPABILITIES_SUMMARY__CANCEL',
}
export interface ICapabilitiesSummaryRaw {
  editionTypes: EditionType[]
  maxFileSizeMb: number
  mediaTypes: Array<{ extension: string; title: string }>
}
export interface ICapabilitiesSummary {
  editionTypes: EditionType[]
  maxFileSizeMb: number
  allowedExtensions: string[]
}
export interface ICapabilitiesSummaryState {
  isLoading: boolean,
  groups: {
    [key: string]: ICapabilitiesSummary
  }
}

export interface IGetCapabilitiesSummaryAction {
  type: types.GET_CAPABILITIES_SUMMARY__START
  groupId: string
}

export interface IGetCapabilitiesSummarySuccessAction {
  type: types.GET_CAPABILITIES_SUMMARY__SUCCESS
  groupId: string
  data: ICapabilitiesSummary
}

export interface IGetCapabilitiesSummaryFailureAction {
  type: types.GET_CAPABILITIES_SUMMARY__FAILURE
  message: string
}

export interface IGetCapabilitiesSummaryCancelAction {
  type: types.GET_CAPABILITIES_SUMMARY__CANCEL
}

export type CapabilitiesSummeryActionsType =
  | IGetCapabilitiesSummaryAction
  | IGetCapabilitiesSummarySuccessAction
  | IGetCapabilitiesSummaryFailureAction
  | IGetCapabilitiesSummaryCancelAction
  | IInitAction
